import { SelectInput, SelectInputProps } from "react-admin"


interface CurrencySelectorProps extends React.PropsWithChildren<SelectInputProps> {
    type?: "user" | "product"
}

const currencies = {
    user: ["USD", "EUR", "GBP"].map(c => ({ id: c, name: c })),
    product: ["USD", "EUR", "GBP", "BUSD", "USDT"].map(c => ({ id: c, name: c }))
}


export function CurrencySelector({ type = "user", ...rest }: CurrencySelectorProps) {



    return (<SelectInput
        choices={currencies[type]}
        {...rest}
    />)
}